import { APICore } from './apiCore'

const api = new APICore()

function getAllSalas (id) {
  const baseUrl = `/chat/salas/${id}`
  return api.get(baseUrl, {})
}

function getUserChat (id) {
  const baseUrl = `/chat/user/${id}`
  return api.get(baseUrl, {})
}

function getAllUsersChat (id) {
  const baseUrl = `/chat/users/${id}`
  return api.get(baseUrl, {})
}

function getUsuariosInSala (id) {
  const baseUrl = `/chat/users-sala/${id}`
  return api.get(baseUrl, {})
}

function getMessages (params) {
  const baseUrl = '/chat/messages'
  return api.create(baseUrl, params)
}

function addMessage (params) {
  const baseUrl = '/chat/message'
  return api.create(baseUrl, params)
}

function getNotifications (id) {
  const baseUrl = `/chat/notifications/${id}`
  return api.get(baseUrl, {})
}

function updatePinnedChats (params) {
  const baseUrl = '/chat/pinned'
  return api.create(baseUrl, params)
}

function updateNotifications (params) {
  const baseUrl = '/chat/notifications'
  return api.create(baseUrl, params)
}

function missingMessages (params) {
  const baseUrl = '/chat/missing-messages'
  return api.create(baseUrl, params)
}

function deleteMessage (params) {
  const baseUrl = '/chat/message'
  return api.delete(baseUrl, params)
}

// File Manager
function uploadFile (params) {
  const baseUrl = '/chat/upload'
  return api.createWithFile(baseUrl, params)
}

function downloadFile (params) {
  const baseUrl = '/chat/download'
  return api.create(baseUrl, params, { responseType: 'blob' })
}

function listFiles (params) {
  const baseUrl = '/chat/files'
  return api.create(baseUrl, params)
}

function createFolder (params) {
  const baseUrl = '/chat/folder'
  return api.create(baseUrl, params)
}

function deleteFile (params) {
  const baseUrl = '/chat/file'
  return api.delete(baseUrl, params)
}

// Calendar
function listEventosCalendario (id) {
  const baseUrl = `/chat/eventos/${id}`
  return api.get(baseUrl, {})
}

function createEventoCalendario (params) {
  const baseUrl = '/chat/evento'
  return api.create(baseUrl, params)
}

function updateEventoCalendario (params) {
  const baseUrl = '/chat/evento'
  return api.update(baseUrl, params)
}

function deleteEventoCalendario (params) {
  const baseUrl = '/chat/evento'
  return api.delete(baseUrl, params)
}

export {
  getAllSalas,
  getUserChat,
  getAllUsersChat,
  getUsuariosInSala,
  getMessages,
  addMessage,
  getNotifications,
  updatePinnedChats,
  updateNotifications,
  missingMessages,
  deleteMessage,
  uploadFile,
  downloadFile,
  listFiles,
  createFolder,
  deleteFile,
  listEventosCalendario,
  createEventoCalendario,
  updateEventoCalendario,
  deleteEventoCalendario
}
